//INFO: We use this ranking/ordering as our way to sort the settings in the 
export enum SettingsGroupName {
    general = "general",
    advanced = "advanced",
    testing = "testing"
}